/* Polite Society wishlist — no app required.
   Stores product handles in localStorage (key ps_wishlist). Syncs:
   • [data-ps-wish="handle"] toggle buttons (cards, PDP) → .is-active
   • [data-ps-wish-count] badges in the header
   • <div data-ps-wishlist-page> renders saved products via /products/{handle}.js
   Emits "ps:wishlist" on window whenever the list changes. */
(function () {
  var KEY = 'ps_wishlist';
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function read() {
    try {
      var l = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(l)) return [];
      // keep only valid product handles (strings), de-duplicated
      return l.filter(function (h, i) { return typeof h === 'string' && /^[a-z0-9-]+$/.test(h) && l.indexOf(h) === i; });
    } catch (e) { return []; }
  }
  function write(list) {
    var ok = true;
    try { localStorage.setItem(KEY, JSON.stringify(list)); }
    catch (e) { ok = false; }            /* private mode, or the origin quota is full */
    window.dispatchEvent(new CustomEvent('ps:wishlist', { detail: list }));
    return ok;
  }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) {
    var l = read(); var i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.unshift(h);
    return { added: i === -1, saved: write(l) };
  }

  function sync(root) {
    var list = read();
    (root || document).querySelectorAll('[data-ps-wish]').forEach(function (b) {
      var on = list.indexOf(b.dataset.psWish) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-ps-wish-count]').forEach(function (c) {
      c.textContent = list.length ? '(' + list.length + ')' : '';
      c.hidden = !list.length;
    });
  }

  /* ---- add animation: image flies to the header bookmark, icon bumps, toast confirms ---- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function findImage(btn) {
    var scope = btn.closest('[data-ps-card]') || btn.closest('[data-ps-product]') || btn.parentElement;
    return scope ? scope.querySelector('.ps-card__img--main, .ps-card__img, .ps-pdp__media img, img') : null;
  }
  function fly(btn) {
    var target = document.querySelector('.ps-header__icon--wishlist');
    var img = findImage(btn);
    if (target) { target.classList.remove('is-bumping'); void target.offsetWidth; }
    if (!img || !target || reduce) { if (target) target.classList.add('is-bumping'); return; }
    var from = img.getBoundingClientRect(), to = target.getBoundingClientRect();
    if (!from.width || !to.width) { target.classList.add('is-bumping'); return; }
    var clone = document.createElement('img');
    clone.src = img.currentSrc || img.src; clone.className = 'ps-fly';
    var w = Math.min(from.width, 160), h = w * (from.height / from.width);
    clone.style.width = w + 'px'; clone.style.height = h + 'px';
    clone.style.left = (from.left + from.width / 2 - w / 2) + 'px'; clone.style.top = (from.top + from.height / 2 - h / 2) + 'px';
    document.body.appendChild(clone);
    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
    var anim = clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, offset: 0 },
      { transform: 'translate(' + (dx * 0.35) + 'px,' + (dy * 0.15 - 60) + 'px) scale(.7)', opacity: 1, offset: .35 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.06)', opacity: .4, offset: 1 }
    ], { duration: 750, easing: 'cubic-bezier(.3,.7,.2,1)', fill: 'forwards' });
    anim.onfinish = function () { clone.remove(); target.classList.add('is-bumping'); setTimeout(function () { target.classList.remove('is-bumping'); }, 700); };
  }
  var toastTimer;
  function toast(btn) {
    var url = (window.psWishlistUrl || '/pages/wishlist');
    var img = findImage(btn);
    var el = document.querySelector('.ps-wish-toast');
    if (!el) { el = document.createElement('div'); el.className = 'ps-wish-toast ps-label'; document.body.appendChild(el); }
    el.innerHTML = (img ? '<img src="' + (img.currentSrc || img.src) + '" alt="">' : '') + '<span>Saved to your wishlist · <a href="' + url + '">View</a></span>';
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ps-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var res = toggle(b.dataset.psWish);
    sync();
    b.classList.remove('is-popping'); void b.offsetWidth; b.classList.add('is-popping');
    /* only claim it was saved when storage actually took it */
    if (res.added && res.saved) { toast(b); } /* fly-to-header animation removed (Arnav, 21 Sep); snackbar kept */
    else if (res.added && !res.saved) { b.setAttribute('aria-pressed', 'false'); b.classList.remove('is-active'); }
  });
  window.addEventListener('ps:wishlist', function () { sync(); });
  window.addEventListener('storage', function (e) {
    /* another tab changed the list — re-render the page grid, not just the badges */
    if (e.key !== KEY) return;
    sync();
    document.querySelectorAll('[data-ps-wishlist-page]').forEach(function (page) { renderPage(page); });
  });
  document.addEventListener('shopify:section:load', function (e) { sync(e.target); });

  /* ---- wishlist page ---- */
  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, amount.split('.')[0]).replace(/<[^>]+>/g, '');
  }
  function renderPage(page) {
    var list = read();
    var grid = page.querySelector('[data-ps-wishlist-grid]');
    var empty = page.querySelector('[data-ps-wishlist-empty]');
    if (!grid) return;
    grid.innerHTML = '';
    if (!list.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    var pending = list.length, rendered = 0, bad = [];
    var settle = function () {
      if (--pending > 0) return;
      if (bad.length) { write(list.filter(function (h) { return bad.indexOf(h) === -1; })); } // prune dead handles → count corrects itself
      if (!rendered && empty) empty.hidden = false;
    };
    list.forEach(function (handle) {
      var li = document.createElement('li'); li.className = 'ps-grid__item'; li.dataset.handle = handle;
      grid.appendChild(li);
      fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { if (!r.ok) throw { gone: r.status === 404 }; return r.json(); }).then(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=800' : '';
        li.innerHTML =
          '<div class="ps-card ps-card--grid" data-ps-card>' +
            '<a href="' + esc(p.url) + '" class="ps-card__media-link"><div class="ps-media ps-media--2x3 ps-card__media">' +
              (img ? '<img class="ps-card__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '</div></a>' +
            '<button type="button" class="ps-card__wish is-active" data-ps-wish="' + esc(handle) + '" aria-label="Remove from wishlist" aria-pressed="true">' + wishSvg + '</button>' +
            '<div class="ps-card__info"><div class="ps-card__row">' +
              '<h3 class="ps-card__title"><a href="' + esc(p.url) + '" class="ps-card__title-link">' + esc(p.title) + '</a></h3>' +
              '<div class="ps-card__price">' + money(p.price) + '</div>' +
            '</div></div>' +
          '</div>';
        rendered++; settle();
      }).catch(function (err) {
        li.remove();
        /* 404 means the product is gone; anything else is a network blip — keep the save */
        if (err && err.gone) bad.push(handle);
        settle();
      });
    });
  }
  var wishSvg = '<svg class="ps-icon ps-icon--wishlist-card ps-icon--wishlist" width="12" height="12" viewBox="1.333 1.333 83.42 83.167" fill="none" aria-hidden="true" style="overflow:visible"><path class="ps-icon__fill" d="M1.33301 1.33334H84.753V84.5L43.0423 59.2667L1.33301 84.5V1.33334Z" stroke="currentColor" stroke-width="0.887361" vector-effect="non-scaling-stroke" stroke-miterlimit="10"/></svg>';

  function boot() {
    sync();
    document.querySelectorAll('[data-ps-wishlist-page]').forEach(function (page) {
      renderPage(page);
      window.addEventListener('ps:wishlist', function (e) {
        // re-render only when the set of handles actually changed vs what's on screen
        var shown = [].map.call(page.querySelectorAll('[data-ps-wishlist-grid] li'), function (li) { return li.dataset.handle; }).join(',');
        if ((e.detail || []).join(',') !== shown) renderPage(page);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.psWishlist = { read: read, has: has, toggle: toggle, sync: sync };
})();
